/**
 * Links into the handbook (spec §8.24) `[M23]`.
 *
 * The handbook ships with the product at `/docs/`, in the same three languages as the interface,
 * so a help link is the reader's own language plus the page for whatever they are looking at.
 * English is the root locale and carries no prefix.
 */
import type { Language } from "./core";

export const DOCS_BASE = "/docs/";

/** `helpUrl("guides/linking/", "de")` → `/docs/de/guides/linking/`. */
export function helpUrl(page = "", language: Language = "en"): string {
  const prefix = language === "en" ? "" : `${language}/`;
  return `${DOCS_BASE}${prefix}${page}`;
}

/**
 * Which handbook page explains the screen at `path`. A pure function of the route, so the mapping
 * is testable without a browser: the app bar's handbook link asks this and nothing else.
 */
export function helpPageFor(path: string): string {
  const p = path.replace(/^\/+|\/+$/g, "").split("/");
  if (p[0] === "settings") return "admin/server-settings/"; // [M26]
  if (p[0] !== "w" || p.length < 2) return ""; // the workspace list and anything unrecognised
  switch (p[2]) {
    case "d":
      return "guides/pages/";
    case "graph":
      return "guides/graph/";
    case "review":
      return "guides/review/";
    case "settings":
      return "guides/settings/";
    default:
      return "guides/workspaces/";
  }
}
